(function () {
  function initAccordion(btn) {
    var body = document.getElementById(btn.getAttribute('aria-controls'));
    if (!body) return;

   
    body.style.transition = 'none';
    body.style.height = btn.getAttribute('aria-expanded') === 'true'
      ? body.scrollHeight + 'px'
      : '0';
    requestAnimationFrame(function () {
      body.style.transition = '';
    });

    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        body.style.height = body.scrollHeight + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { body.style.height = '0'; });
        });
        btn.setAttribute('aria-expanded', 'false');
      } else {
        body.style.height = body.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        body.addEventListener('transitionend', function done() {
          body.style.height = 'auto';
          body.removeEventListener('transitionend', done);
        });
      }
    });
  }

  document.querySelectorAll('.cw-acc-header[aria-controls]').forEach(initAccordion);
}());
